/* eslint-disable */
// @ts-nocheck

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { deleteApiAdminCheckinsByGuestIdUsersByLineUserId, deleteApiAdminCheckinsById, deleteApiAdminGuestById, deleteApiRichmenusById, deleteApiRichmenusDefault, deleteApiRichmenusLinkByLineUserId, deleteApiTablesMasterById, getApiActivitiesWall, getApiAdminCheckins, getApiAdminGuest, getApiAdminGuestById, getApiAdminUsers, getApiAuthMe, getApiAuthToken, getApiGuests, getApiGuestsById, getApiGuestsGroups, getApiRichmenus, getApiRichmenusById, getApiRichmenusUserByLineUserId, getApiSettings, getApiTables, getApiTablesGuestByTargetId, getApiTablesMaster, getApiTablesMasterAll, getApiTablesMasterById, getApiTablesMasterByIdGuests, type Options, patchApiAdminGuestById, patchApiAdminUsersById, patchApiSettings, patchApiTablesMasterById, postApiActivitiesLogBlessing, postApiActivitiesRandomNumber, postApiActivitiesSubmitAngpao, postApiActivitiesWall, postApiActivitiesWallBackground, postApiAdminCheckinsManual, postApiAdminGuest, postApiAdminGuestBulkMapLineIds, postApiAdminGuestImport, postApiCheckins, postApiRichmenus, postApiRichmenusByIdDefault, postApiRichmenusByIdImage, postApiRichmenusByIdLinkByLineUserId, postApiRichmenusSyncAll, postApiTables, postApiTablesBulk, postApiTablesMaster, postApiTablesMasterImport, postApiTablesUnassign } from '../sdk.gen';
import type { DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdData, DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdError, DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdResponse, DeleteApiAdminCheckinsByIdData, DeleteApiAdminCheckinsByIdError, DeleteApiAdminCheckinsByIdResponse, DeleteApiAdminGuestByIdData, DeleteApiAdminGuestByIdError, DeleteApiAdminGuestByIdResponse, DeleteApiRichmenusByIdData, DeleteApiRichmenusByIdError, DeleteApiRichmenusByIdResponse, DeleteApiRichmenusDefaultData, DeleteApiRichmenusDefaultError, DeleteApiRichmenusDefaultResponse, DeleteApiRichmenusLinkByLineUserIdData, DeleteApiRichmenusLinkByLineUserIdError, DeleteApiRichmenusLinkByLineUserIdResponse, DeleteApiTablesMasterByIdData, DeleteApiTablesMasterByIdError, DeleteApiTablesMasterByIdResponse, GetApiActivitiesWallData, GetApiActivitiesWallError, GetApiActivitiesWallResponse, GetApiAdminCheckinsData, GetApiAdminCheckinsError, GetApiAdminCheckinsResponse, GetApiAdminGuestByIdData, GetApiAdminGuestByIdError, GetApiAdminGuestByIdResponse, GetApiAdminGuestData, GetApiAdminGuestError, GetApiAdminGuestResponse, GetApiAdminUsersData, GetApiAdminUsersError, GetApiAdminUsersResponse, GetApiAuthMeData, GetApiAuthMeError, GetApiAuthMeResponse, GetApiAuthTokenData, GetApiAuthTokenError, GetApiAuthTokenResponse, GetApiGuestsByIdData, GetApiGuestsByIdError, GetApiGuestsByIdResponse, GetApiGuestsData, GetApiGuestsError, GetApiGuestsGroupsData, GetApiGuestsGroupsError, GetApiGuestsGroupsResponse, GetApiGuestsResponse, GetApiRichmenusByIdData, GetApiRichmenusByIdError, GetApiRichmenusByIdResponse, GetApiRichmenusData, GetApiRichmenusError, GetApiRichmenusResponse, GetApiRichmenusUserByLineUserIdData, GetApiRichmenusUserByLineUserIdError, GetApiRichmenusUserByLineUserIdResponse, GetApiSettingsData, GetApiSettingsError, GetApiSettingsResponse, GetApiTablesData, GetApiTablesError, GetApiTablesGuestByTargetIdData, GetApiTablesGuestByTargetIdError, GetApiTablesGuestByTargetIdResponse, GetApiTablesMasterAllData, GetApiTablesMasterAllError, GetApiTablesMasterAllResponse, GetApiTablesMasterByIdData, GetApiTablesMasterByIdError, GetApiTablesMasterByIdGuestsData, GetApiTablesMasterByIdGuestsError, GetApiTablesMasterByIdGuestsResponse, GetApiTablesMasterByIdResponse, GetApiTablesMasterData, GetApiTablesMasterError, GetApiTablesMasterResponse, GetApiTablesResponse, PatchApiAdminGuestByIdData, PatchApiAdminGuestByIdError, PatchApiAdminGuestByIdResponse, PatchApiAdminUsersByIdData, PatchApiAdminUsersByIdError, PatchApiAdminUsersByIdResponse, PatchApiSettingsData, PatchApiSettingsError, PatchApiSettingsResponse, PatchApiTablesMasterByIdData, PatchApiTablesMasterByIdError, PatchApiTablesMasterByIdResponse, PostApiActivitiesLogBlessingData, PostApiActivitiesLogBlessingError, PostApiActivitiesLogBlessingResponse, PostApiActivitiesRandomNumberData, PostApiActivitiesRandomNumberError, PostApiActivitiesRandomNumberResponse, PostApiActivitiesSubmitAngpaoData, PostApiActivitiesSubmitAngpaoError, PostApiActivitiesSubmitAngpaoResponse, PostApiActivitiesWallBackgroundData, PostApiActivitiesWallBackgroundError, PostApiActivitiesWallBackgroundResponse, PostApiActivitiesWallData, PostApiActivitiesWallError, PostApiActivitiesWallResponse, PostApiAdminCheckinsManualData, PostApiAdminCheckinsManualError, PostApiAdminCheckinsManualResponse, PostApiAdminGuestBulkMapLineIdsData, PostApiAdminGuestBulkMapLineIdsError, PostApiAdminGuestBulkMapLineIdsResponse, PostApiAdminGuestData, PostApiAdminGuestError, PostApiAdminGuestImportData, PostApiAdminGuestImportError, PostApiAdminGuestImportResponse, PostApiAdminGuestResponse, PostApiCheckinsData, PostApiCheckinsError, PostApiCheckinsResponse, PostApiRichmenusByIdDefaultData, PostApiRichmenusByIdDefaultError, PostApiRichmenusByIdDefaultResponse, PostApiRichmenusByIdImageData, PostApiRichmenusByIdImageError, PostApiRichmenusByIdImageResponse, PostApiRichmenusByIdLinkByLineUserIdData, PostApiRichmenusByIdLinkByLineUserIdError, PostApiRichmenusByIdLinkByLineUserIdResponse, PostApiRichmenusData, PostApiRichmenusError, PostApiRichmenusResponse, PostApiRichmenusSyncAllData, PostApiRichmenusSyncAllError, PostApiRichmenusSyncAllResponse, PostApiTablesBulkData, PostApiTablesBulkError, PostApiTablesBulkResponse, PostApiTablesData, PostApiTablesError, PostApiTablesMasterData, PostApiTablesMasterError, PostApiTablesMasterImportData, PostApiTablesMasterImportError, PostApiTablesMasterImportResponse, PostApiTablesMasterResponse, PostApiTablesResponse, PostApiTablesUnassignData, PostApiTablesUnassignError, PostApiTablesUnassignResponse } from '../types.gen';

/**
 * Create a new check-in record
 */
export const postApiCheckinsMutation = (options?: Partial<Options<PostApiCheckinsData>>): UseMutationOptions<PostApiCheckinsResponse, PostApiCheckinsError, Options<PostApiCheckinsData>> => {
    const mutationOptions: UseMutationOptions<PostApiCheckinsResponse, PostApiCheckinsError, Options<PostApiCheckinsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiCheckins({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getApiTablesMasterQueryKey = (options?: Options<GetApiTablesMasterData>) => createQueryKey('getApiTablesMaster', options);

/**
 * List all master tables
 */
export const getApiTablesMasterOptions = (options?: Options<GetApiTablesMasterData>) => queryOptions<GetApiTablesMasterResponse, GetApiTablesMasterError, GetApiTablesMasterResponse, ReturnType<typeof getApiTablesMasterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiTablesMaster({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTablesMasterQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getApiTablesMasterInfiniteQueryKey = (options?: Options<GetApiTablesMasterData>): QueryKey<Options<GetApiTablesMasterData>> => createQueryKey('getApiTablesMaster', options, true);

/**
 * List all master tables
 */
export const getApiTablesMasterInfiniteOptions = (options?: Options<GetApiTablesMasterData>) => infiniteQueryOptions<GetApiTablesMasterResponse, GetApiTablesMasterError, InfiniteData<GetApiTablesMasterResponse>, QueryKey<Options<GetApiTablesMasterData>>, number | Pick<QueryKey<Options<GetApiTablesMasterData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiTablesMasterData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiTablesMaster({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTablesMasterInfiniteQueryKey(options)
});

/**
 * Create a new master table
 */
export const postApiTablesMasterMutation = (options?: Partial<Options<PostApiTablesMasterData>>): UseMutationOptions<PostApiTablesMasterResponse, PostApiTablesMasterError, Options<PostApiTablesMasterData>> => {
    const mutationOptions: UseMutationOptions<PostApiTablesMasterResponse, PostApiTablesMasterError, Options<PostApiTablesMasterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiTablesMaster({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a master table
 */
export const deleteApiTablesMasterByIdMutation = (options?: Partial<Options<DeleteApiTablesMasterByIdData>>): UseMutationOptions<DeleteApiTablesMasterByIdResponse, DeleteApiTablesMasterByIdError, Options<DeleteApiTablesMasterByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiTablesMasterByIdResponse, DeleteApiTablesMasterByIdError, Options<DeleteApiTablesMasterByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiTablesMasterById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiTablesMasterByIdQueryKey = (options: Options<GetApiTablesMasterByIdData>) => createQueryKey('getApiTablesMasterById', options);

/**
 * Get master table details
 */
export const getApiTablesMasterByIdOptions = (options: Options<GetApiTablesMasterByIdData>) => queryOptions<GetApiTablesMasterByIdResponse, GetApiTablesMasterByIdError, GetApiTablesMasterByIdResponse, ReturnType<typeof getApiTablesMasterByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiTablesMasterById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTablesMasterByIdQueryKey(options)
});

/**
 * Update master table metadata
 */
export const patchApiTablesMasterByIdMutation = (options?: Partial<Options<PatchApiTablesMasterByIdData>>): UseMutationOptions<PatchApiTablesMasterByIdResponse, PatchApiTablesMasterByIdError, Options<PatchApiTablesMasterByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchApiTablesMasterByIdResponse, PatchApiTablesMasterByIdError, Options<PatchApiTablesMasterByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiTablesMasterById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiTablesMasterAllQueryKey = (options?: Options<GetApiTablesMasterAllData>) => createQueryKey('getApiTablesMasterAll', options);

/**
 * List all master tables (no pagination)
 */
export const getApiTablesMasterAllOptions = (options?: Options<GetApiTablesMasterAllData>) => queryOptions<GetApiTablesMasterAllResponse, GetApiTablesMasterAllError, GetApiTablesMasterAllResponse, ReturnType<typeof getApiTablesMasterAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiTablesMasterAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTablesMasterAllQueryKey(options)
});

/**
 * Import master tables from CSV
 */
export const postApiTablesMasterImportMutation = (options?: Partial<Options<PostApiTablesMasterImportData>>): UseMutationOptions<PostApiTablesMasterImportResponse, PostApiTablesMasterImportError, Options<PostApiTablesMasterImportData>> => {
    const mutationOptions: UseMutationOptions<PostApiTablesMasterImportResponse, PostApiTablesMasterImportError, Options<PostApiTablesMasterImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiTablesMasterImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiTablesQueryKey = (options?: Options<GetApiTablesData>) => createQueryKey('getApiTables', options);

/**
 * List all table assignments
 */
export const getApiTablesOptions = (options?: Options<GetApiTablesData>) => queryOptions<GetApiTablesResponse, GetApiTablesError, GetApiTablesResponse, ReturnType<typeof getApiTablesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiTables({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTablesQueryKey(options)
});

export const getApiTablesInfiniteQueryKey = (options?: Options<GetApiTablesData>): QueryKey<Options<GetApiTablesData>> => createQueryKey('getApiTables', options, true);

/**
 * List all table assignments
 */
export const getApiTablesInfiniteOptions = (options?: Options<GetApiTablesData>) => infiniteQueryOptions<GetApiTablesResponse, GetApiTablesError, InfiniteData<GetApiTablesResponse>, QueryKey<Options<GetApiTablesData>>, number | Pick<QueryKey<Options<GetApiTablesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiTablesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiTables({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTablesInfiniteQueryKey(options)
});

/**
 * Assign a table to a guest
 */
export const postApiTablesMutation = (options?: Partial<Options<PostApiTablesData>>): UseMutationOptions<PostApiTablesResponse, PostApiTablesError, Options<PostApiTablesData>> => {
    const mutationOptions: UseMutationOptions<PostApiTablesResponse, PostApiTablesError, Options<PostApiTablesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiTables({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unassign/remove a table from a guest
 */
export const postApiTablesUnassignMutation = (options?: Partial<Options<PostApiTablesUnassignData>>): UseMutationOptions<PostApiTablesUnassignResponse, PostApiTablesUnassignError, Options<PostApiTablesUnassignData>> => {
    const mutationOptions: UseMutationOptions<PostApiTablesUnassignResponse, PostApiTablesUnassignError, Options<PostApiTablesUnassignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiTablesUnassign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign multiple guest groups to a table
 */
export const postApiTablesBulkMutation = (options?: Partial<Options<PostApiTablesBulkData>>): UseMutationOptions<PostApiTablesBulkResponse, PostApiTablesBulkError, Options<PostApiTablesBulkData>> => {
    const mutationOptions: UseMutationOptions<PostApiTablesBulkResponse, PostApiTablesBulkError, Options<PostApiTablesBulkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiTablesBulk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiTablesGuestByTargetIdQueryKey = (options?: Options<GetApiTablesGuestByTargetIdData>) => createQueryKey('getApiTablesGuestByTargetId', options);

/**
 * Get table assignment for a guest
 */
export const getApiTablesGuestByTargetIdOptions = (options?: Options<GetApiTablesGuestByTargetIdData>) => queryOptions<GetApiTablesGuestByTargetIdResponse, GetApiTablesGuestByTargetIdError, GetApiTablesGuestByTargetIdResponse, ReturnType<typeof getApiTablesGuestByTargetIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiTablesGuestByTargetId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTablesGuestByTargetIdQueryKey(options)
});

export const getApiTablesMasterByIdGuestsQueryKey = (options: Options<GetApiTablesMasterByIdGuestsData>) => createQueryKey('getApiTablesMasterByIdGuests', options);

/**
 * List guests for a table
 */
export const getApiTablesMasterByIdGuestsOptions = (options: Options<GetApiTablesMasterByIdGuestsData>) => queryOptions<GetApiTablesMasterByIdGuestsResponse, GetApiTablesMasterByIdGuestsError, GetApiTablesMasterByIdGuestsResponse, ReturnType<typeof getApiTablesMasterByIdGuestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiTablesMasterByIdGuests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTablesMasterByIdGuestsQueryKey(options)
});

export const getApiGuestsQueryKey = (options?: Options<GetApiGuestsData>) => createQueryKey('getApiGuests', options);

/**
 * List all guests in the master list
 */
export const getApiGuestsOptions = (options?: Options<GetApiGuestsData>) => queryOptions<GetApiGuestsResponse, GetApiGuestsError, GetApiGuestsResponse, ReturnType<typeof getApiGuestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiGuests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiGuestsQueryKey(options)
});

export const getApiGuestsInfiniteQueryKey = (options?: Options<GetApiGuestsData>): QueryKey<Options<GetApiGuestsData>> => createQueryKey('getApiGuests', options, true);

/**
 * List all guests in the master list
 */
export const getApiGuestsInfiniteOptions = (options?: Options<GetApiGuestsData>) => infiniteQueryOptions<GetApiGuestsResponse, GetApiGuestsError, InfiniteData<GetApiGuestsResponse>, QueryKey<Options<GetApiGuestsData>>, number | Pick<QueryKey<Options<GetApiGuestsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiGuestsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiGuests({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiGuestsInfiniteQueryKey(options)
});

export const getApiGuestsGroupsQueryKey = (options?: Options<GetApiGuestsGroupsData>) => createQueryKey('getApiGuestsGroups', options);

/**
 * Get all unique guest groups
 */
export const getApiGuestsGroupsOptions = (options?: Options<GetApiGuestsGroupsData>) => queryOptions<GetApiGuestsGroupsResponse, GetApiGuestsGroupsError, GetApiGuestsGroupsResponse, ReturnType<typeof getApiGuestsGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiGuestsGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiGuestsGroupsQueryKey(options)
});

export const getApiGuestsByIdQueryKey = (options: Options<GetApiGuestsByIdData>) => createQueryKey('getApiGuestsById', options);

/**
 * Get guest details
 */
export const getApiGuestsByIdOptions = (options: Options<GetApiGuestsByIdData>) => queryOptions<GetApiGuestsByIdResponse, GetApiGuestsByIdError, GetApiGuestsByIdResponse, ReturnType<typeof getApiGuestsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiGuestsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiGuestsByIdQueryKey(options)
});

export const getApiAuthTokenQueryKey = (options?: Options<GetApiAuthTokenData>) => createQueryKey('getApiAuthToken', options);

/**
 * Get Firebase custom token for the authenticated user
 */
export const getApiAuthTokenOptions = (options?: Options<GetApiAuthTokenData>) => queryOptions<GetApiAuthTokenResponse, GetApiAuthTokenError, GetApiAuthTokenResponse, ReturnType<typeof getApiAuthTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiAuthToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAuthTokenQueryKey(options)
});

export const getApiAuthMeQueryKey = (options?: Options<GetApiAuthMeData>) => createQueryKey('getApiAuthMe', options);

/**
 * Get current user status and profile
 */
export const getApiAuthMeOptions = (options?: Options<GetApiAuthMeData>) => queryOptions<GetApiAuthMeResponse, GetApiAuthMeError, GetApiAuthMeResponse, ReturnType<typeof getApiAuthMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiAuthMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAuthMeQueryKey(options)
});

/**
 * Log a wedding blessing
 */
export const postApiActivitiesLogBlessingMutation = (options?: Partial<Options<PostApiActivitiesLogBlessingData>>): UseMutationOptions<PostApiActivitiesLogBlessingResponse, PostApiActivitiesLogBlessingError, Options<PostApiActivitiesLogBlessingData>> => {
    const mutationOptions: UseMutationOptions<PostApiActivitiesLogBlessingResponse, PostApiActivitiesLogBlessingError, Options<PostApiActivitiesLogBlessingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiActivitiesLogBlessing({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit a wedding e-angpao slip
 */
export const postApiActivitiesSubmitAngpaoMutation = (options?: Partial<Options<PostApiActivitiesSubmitAngpaoData>>): UseMutationOptions<PostApiActivitiesSubmitAngpaoResponse, PostApiActivitiesSubmitAngpaoError, Options<PostApiActivitiesSubmitAngpaoData>> => {
    const mutationOptions: UseMutationOptions<PostApiActivitiesSubmitAngpaoResponse, PostApiActivitiesSubmitAngpaoError, Options<PostApiActivitiesSubmitAngpaoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiActivitiesSubmitAngpao({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit a random number for Lucky Draw
 */
export const postApiActivitiesRandomNumberMutation = (options?: Partial<Options<PostApiActivitiesRandomNumberData>>): UseMutationOptions<PostApiActivitiesRandomNumberResponse, PostApiActivitiesRandomNumberError, Options<PostApiActivitiesRandomNumberData>> => {
    const mutationOptions: UseMutationOptions<PostApiActivitiesRandomNumberResponse, PostApiActivitiesRandomNumberError, Options<PostApiActivitiesRandomNumberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiActivitiesRandomNumber({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload a custom wall background image
 */
export const postApiActivitiesWallBackgroundMutation = (options?: Partial<Options<PostApiActivitiesWallBackgroundData>>): UseMutationOptions<PostApiActivitiesWallBackgroundResponse, PostApiActivitiesWallBackgroundError, Options<PostApiActivitiesWallBackgroundData>> => {
    const mutationOptions: UseMutationOptions<PostApiActivitiesWallBackgroundResponse, PostApiActivitiesWallBackgroundError, Options<PostApiActivitiesWallBackgroundData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiActivitiesWallBackground({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiActivitiesWallQueryKey = (options?: Options<GetApiActivitiesWallData>) => createQueryKey('getApiActivitiesWall', options);

/**
 * Get the current wall settings, sessions, and winners
 */
export const getApiActivitiesWallOptions = (options?: Options<GetApiActivitiesWallData>) => queryOptions<GetApiActivitiesWallResponse, GetApiActivitiesWallError, GetApiActivitiesWallResponse, ReturnType<typeof getApiActivitiesWallQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiActivitiesWall({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiActivitiesWallQueryKey(options)
});

/**
 * Update the wall settings, sessions, and winners
 */
export const postApiActivitiesWallMutation = (options?: Partial<Options<PostApiActivitiesWallData>>): UseMutationOptions<PostApiActivitiesWallResponse, PostApiActivitiesWallError, Options<PostApiActivitiesWallData>> => {
    const mutationOptions: UseMutationOptions<PostApiActivitiesWallResponse, PostApiActivitiesWallError, Options<PostApiActivitiesWallData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiActivitiesWall({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiSettingsQueryKey = (options?: Options<GetApiSettingsData>) => createQueryKey('getApiSettings', options);

/**
 * Get global wedding settings
 */
export const getApiSettingsOptions = (options?: Options<GetApiSettingsData>) => queryOptions<GetApiSettingsResponse, GetApiSettingsError, GetApiSettingsResponse, ReturnType<typeof getApiSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiSettingsQueryKey(options)
});

/**
 * Update global wedding settings
 */
export const patchApiSettingsMutation = (options?: Partial<Options<PatchApiSettingsData>>): UseMutationOptions<PatchApiSettingsResponse, PatchApiSettingsError, Options<PatchApiSettingsData>> => {
    const mutationOptions: UseMutationOptions<PatchApiSettingsResponse, PatchApiSettingsError, Options<PatchApiSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiRichmenusQueryKey = (options?: Options<GetApiRichmenusData>) => createQueryKey('getApiRichmenus', options);

/**
 * Admin: List all LINE rich menus
 */
export const getApiRichmenusOptions = (options?: Options<GetApiRichmenusData>) => queryOptions<GetApiRichmenusResponse, GetApiRichmenusError, GetApiRichmenusResponse, ReturnType<typeof getApiRichmenusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiRichmenus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiRichmenusQueryKey(options)
});

/**
 * Admin: Create a new LINE rich menu configuration
 */
export const postApiRichmenusMutation = (options?: Partial<Options<PostApiRichmenusData>>): UseMutationOptions<PostApiRichmenusResponse, PostApiRichmenusError, Options<PostApiRichmenusData>> => {
    const mutationOptions: UseMutationOptions<PostApiRichmenusResponse, PostApiRichmenusError, Options<PostApiRichmenusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiRichmenus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: Delete a LINE rich menu
 */
export const deleteApiRichmenusByIdMutation = (options?: Partial<Options<DeleteApiRichmenusByIdData>>): UseMutationOptions<DeleteApiRichmenusByIdResponse, DeleteApiRichmenusByIdError, Options<DeleteApiRichmenusByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiRichmenusByIdResponse, DeleteApiRichmenusByIdError, Options<DeleteApiRichmenusByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiRichmenusById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiRichmenusByIdQueryKey = (options: Options<GetApiRichmenusByIdData>) => createQueryKey('getApiRichmenusById', options);

/**
 * Admin: Get details of a LINE rich menu
 */
export const getApiRichmenusByIdOptions = (options: Options<GetApiRichmenusByIdData>) => queryOptions<GetApiRichmenusByIdResponse, GetApiRichmenusByIdError, GetApiRichmenusByIdResponse, ReturnType<typeof getApiRichmenusByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiRichmenusById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiRichmenusByIdQueryKey(options)
});

/**
 * Admin: Cancel global default LINE rich menu
 */
export const deleteApiRichmenusDefaultMutation = (options?: Partial<Options<DeleteApiRichmenusDefaultData>>): UseMutationOptions<DeleteApiRichmenusDefaultResponse, DeleteApiRichmenusDefaultError, Options<DeleteApiRichmenusDefaultData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiRichmenusDefaultResponse, DeleteApiRichmenusDefaultError, Options<DeleteApiRichmenusDefaultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiRichmenusDefault({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: Upload background image for a LINE rich menu
 */
export const postApiRichmenusByIdImageMutation = (options?: Partial<Options<PostApiRichmenusByIdImageData>>): UseMutationOptions<PostApiRichmenusByIdImageResponse, PostApiRichmenusByIdImageError, Options<PostApiRichmenusByIdImageData>> => {
    const mutationOptions: UseMutationOptions<PostApiRichmenusByIdImageResponse, PostApiRichmenusByIdImageError, Options<PostApiRichmenusByIdImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiRichmenusByIdImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: Set global default LINE rich menu
 */
export const postApiRichmenusByIdDefaultMutation = (options?: Partial<Options<PostApiRichmenusByIdDefaultData>>): UseMutationOptions<PostApiRichmenusByIdDefaultResponse, PostApiRichmenusByIdDefaultError, Options<PostApiRichmenusByIdDefaultData>> => {
    const mutationOptions: UseMutationOptions<PostApiRichmenusByIdDefaultResponse, PostApiRichmenusByIdDefaultError, Options<PostApiRichmenusByIdDefaultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiRichmenusByIdDefault({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: Link a LINE rich menu to a specific user
 */
export const postApiRichmenusByIdLinkByLineUserIdMutation = (options?: Partial<Options<PostApiRichmenusByIdLinkByLineUserIdData>>): UseMutationOptions<PostApiRichmenusByIdLinkByLineUserIdResponse, PostApiRichmenusByIdLinkByLineUserIdError, Options<PostApiRichmenusByIdLinkByLineUserIdData>> => {
    const mutationOptions: UseMutationOptions<PostApiRichmenusByIdLinkByLineUserIdResponse, PostApiRichmenusByIdLinkByLineUserIdError, Options<PostApiRichmenusByIdLinkByLineUserIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiRichmenusByIdLinkByLineUserId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: Unlink any personalized LINE rich menu from a specific user
 */
export const deleteApiRichmenusLinkByLineUserIdMutation = (options?: Partial<Options<DeleteApiRichmenusLinkByLineUserIdData>>): UseMutationOptions<DeleteApiRichmenusLinkByLineUserIdResponse, DeleteApiRichmenusLinkByLineUserIdError, Options<DeleteApiRichmenusLinkByLineUserIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiRichmenusLinkByLineUserIdResponse, DeleteApiRichmenusLinkByLineUserIdError, Options<DeleteApiRichmenusLinkByLineUserIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiRichmenusLinkByLineUserId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiRichmenusUserByLineUserIdQueryKey = (options: Options<GetApiRichmenusUserByLineUserIdData>) => createQueryKey('getApiRichmenusUserByLineUserId', options);

/**
 * Admin: Get bound LINE rich menu ID for a specific user
 */
export const getApiRichmenusUserByLineUserIdOptions = (options: Options<GetApiRichmenusUserByLineUserIdData>) => queryOptions<GetApiRichmenusUserByLineUserIdResponse, GetApiRichmenusUserByLineUserIdError, GetApiRichmenusUserByLineUserIdResponse, ReturnType<typeof getApiRichmenusUserByLineUserIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiRichmenusUserByLineUserId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiRichmenusUserByLineUserIdQueryKey(options)
});

/**
 * Admin: Sync conditional rich menus for all users
 */
export const postApiRichmenusSyncAllMutation = (options?: Partial<Options<PostApiRichmenusSyncAllData>>): UseMutationOptions<PostApiRichmenusSyncAllResponse, PostApiRichmenusSyncAllError, Options<PostApiRichmenusSyncAllData>> => {
    const mutationOptions: UseMutationOptions<PostApiRichmenusSyncAllResponse, PostApiRichmenusSyncAllError, Options<PostApiRichmenusSyncAllData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiRichmenusSyncAll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiAdminGuestQueryKey = (options?: Options<GetApiAdminGuestData>) => createQueryKey('getApiAdminGuest', options);

/**
 * Admin: List all guests in the master list with full details
 */
export const getApiAdminGuestOptions = (options?: Options<GetApiAdminGuestData>) => queryOptions<GetApiAdminGuestResponse, GetApiAdminGuestError, GetApiAdminGuestResponse, ReturnType<typeof getApiAdminGuestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiAdminGuest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAdminGuestQueryKey(options)
});

export const getApiAdminGuestInfiniteQueryKey = (options?: Options<GetApiAdminGuestData>): QueryKey<Options<GetApiAdminGuestData>> => createQueryKey('getApiAdminGuest', options, true);

/**
 * Admin: List all guests in the master list with full details
 */
export const getApiAdminGuestInfiniteOptions = (options?: Options<GetApiAdminGuestData>) => infiniteQueryOptions<GetApiAdminGuestResponse, GetApiAdminGuestError, InfiniteData<GetApiAdminGuestResponse>, QueryKey<Options<GetApiAdminGuestData>>, number | Pick<QueryKey<Options<GetApiAdminGuestData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiAdminGuestData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiAdminGuest({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAdminGuestInfiniteQueryKey(options)
});

/**
 * Create a new guest in the master list
 */
export const postApiAdminGuestMutation = (options?: Partial<Options<PostApiAdminGuestData>>): UseMutationOptions<PostApiAdminGuestResponse, PostApiAdminGuestError, Options<PostApiAdminGuestData>> => {
    const mutationOptions: UseMutationOptions<PostApiAdminGuestResponse, PostApiAdminGuestError, Options<PostApiAdminGuestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiAdminGuest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a guest from the master list
 */
export const deleteApiAdminGuestByIdMutation = (options?: Partial<Options<DeleteApiAdminGuestByIdData>>): UseMutationOptions<DeleteApiAdminGuestByIdResponse, DeleteApiAdminGuestByIdError, Options<DeleteApiAdminGuestByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiAdminGuestByIdResponse, DeleteApiAdminGuestByIdError, Options<DeleteApiAdminGuestByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiAdminGuestById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiAdminGuestByIdQueryKey = (options: Options<GetApiAdminGuestByIdData>) => createQueryKey('getApiAdminGuestById', options);

/**
 * Admin: Get guest details with full details
 */
export const getApiAdminGuestByIdOptions = (options: Options<GetApiAdminGuestByIdData>) => queryOptions<GetApiAdminGuestByIdResponse, GetApiAdminGuestByIdError, GetApiAdminGuestByIdResponse, ReturnType<typeof getApiAdminGuestByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiAdminGuestById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAdminGuestByIdQueryKey(options)
});

/**
 * Update guest details
 */
export const patchApiAdminGuestByIdMutation = (options?: Partial<Options<PatchApiAdminGuestByIdData>>): UseMutationOptions<PatchApiAdminGuestByIdResponse, PatchApiAdminGuestByIdError, Options<PatchApiAdminGuestByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchApiAdminGuestByIdResponse, PatchApiAdminGuestByIdError, Options<PatchApiAdminGuestByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiAdminGuestById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Import guests from CSV
 */
export const postApiAdminGuestImportMutation = (options?: Partial<Options<PostApiAdminGuestImportData>>): UseMutationOptions<PostApiAdminGuestImportResponse, PostApiAdminGuestImportError, Options<PostApiAdminGuestImportData>> => {
    const mutationOptions: UseMutationOptions<PostApiAdminGuestImportResponse, PostApiAdminGuestImportError, Options<PostApiAdminGuestImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiAdminGuestImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk map LINE User IDs and metadata to guests
 */
export const postApiAdminGuestBulkMapLineIdsMutation = (options?: Partial<Options<PostApiAdminGuestBulkMapLineIdsData>>): UseMutationOptions<PostApiAdminGuestBulkMapLineIdsResponse, PostApiAdminGuestBulkMapLineIdsError, Options<PostApiAdminGuestBulkMapLineIdsData>> => {
    const mutationOptions: UseMutationOptions<PostApiAdminGuestBulkMapLineIdsResponse, PostApiAdminGuestBulkMapLineIdsError, Options<PostApiAdminGuestBulkMapLineIdsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiAdminGuestBulkMapLineIds({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiAdminUsersQueryKey = (options?: Options<GetApiAdminUsersData>) => createQueryKey('getApiAdminUsers', options);

/**
 * List all users (for admin management)
 */
export const getApiAdminUsersOptions = (options?: Options<GetApiAdminUsersData>) => queryOptions<GetApiAdminUsersResponse, GetApiAdminUsersError, GetApiAdminUsersResponse, ReturnType<typeof getApiAdminUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiAdminUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAdminUsersQueryKey(options)
});

/**
 * Update user admin role and module access
 */
export const patchApiAdminUsersByIdMutation = (options?: Partial<Options<PatchApiAdminUsersByIdData>>): UseMutationOptions<PatchApiAdminUsersByIdResponse, PatchApiAdminUsersByIdError, Options<PatchApiAdminUsersByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchApiAdminUsersByIdResponse, PatchApiAdminUsersByIdError, Options<PatchApiAdminUsersByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiAdminUsersById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiAdminCheckinsQueryKey = (options?: Options<GetApiAdminCheckinsData>) => createQueryKey('getApiAdminCheckins', options);

/**
 * Admin: List all check-ins
 */
export const getApiAdminCheckinsOptions = (options?: Options<GetApiAdminCheckinsData>) => queryOptions<GetApiAdminCheckinsResponse, GetApiAdminCheckinsError, GetApiAdminCheckinsResponse, ReturnType<typeof getApiAdminCheckinsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiAdminCheckins({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAdminCheckinsQueryKey(options)
});

export const getApiAdminCheckinsInfiniteQueryKey = (options?: Options<GetApiAdminCheckinsData>): QueryKey<Options<GetApiAdminCheckinsData>> => createQueryKey('getApiAdminCheckins', options, true);

/**
 * Admin: List all check-ins
 */
export const getApiAdminCheckinsInfiniteOptions = (options?: Options<GetApiAdminCheckinsData>) => infiniteQueryOptions<GetApiAdminCheckinsResponse, GetApiAdminCheckinsError, InfiniteData<GetApiAdminCheckinsResponse>, QueryKey<Options<GetApiAdminCheckinsData>>, number | Pick<QueryKey<Options<GetApiAdminCheckinsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiAdminCheckinsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiAdminCheckins({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAdminCheckinsInfiniteQueryKey(options)
});

/**
 * Admin: Create a manual check-in record (guest without LINE)
 */
export const postApiAdminCheckinsManualMutation = (options?: Partial<Options<PostApiAdminCheckinsManualData>>): UseMutationOptions<PostApiAdminCheckinsManualResponse, PostApiAdminCheckinsManualError, Options<PostApiAdminCheckinsManualData>> => {
    const mutationOptions: UseMutationOptions<PostApiAdminCheckinsManualResponse, PostApiAdminCheckinsManualError, Options<PostApiAdminCheckinsManualData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiAdminCheckinsManual({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: Delete a check-in record
 */
export const deleteApiAdminCheckinsByIdMutation = (options?: Partial<Options<DeleteApiAdminCheckinsByIdData>>): UseMutationOptions<DeleteApiAdminCheckinsByIdResponse, DeleteApiAdminCheckinsByIdError, Options<DeleteApiAdminCheckinsByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiAdminCheckinsByIdResponse, DeleteApiAdminCheckinsByIdError, Options<DeleteApiAdminCheckinsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiAdminCheckinsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin: Remove a specific LINE user from a guest party check-in
 */
export const deleteApiAdminCheckinsByGuestIdUsersByLineUserIdMutation = (options?: Partial<Options<DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdData>>): UseMutationOptions<DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdResponse, DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdError, Options<DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdResponse, DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdError, Options<DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiAdminCheckinsByGuestIdUsersByLineUserId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
